import CardsBlock from "./components/CardsBlock";

document.addEventListener("DOMContentLoaded", () => {
	class App {
		constructor() {
			new CardsBlock();

			this.addEventListeners();
		}

		addEventListeners() {
			document
				.querySelector(".wpml-ls-current")
				.addEventListener("click", function (e) {
					e.preventDefault();
					const parent = this.closest(".w__lang-switcher");
					parent.classList.toggle("is-active");
				});

			document.addEventListener("click", function (e) {
				if (!e.target.closest(".w__lang-switcher")) {
					document
						.querySelector(".w__lang-switcher")
						.classList.remove("is-active");
				}
			});
		}
	}

	new App();
});
